module.exports = __webpack_public_path__ + "media/images/flags/ms-9474f8cf128ce6813e2d501b08cfd7a0.svg";